import {
  ArtworkResponse,
  CheckJCUserResponse,
  HeaderEnrichmentResponse,
  JcPlanResponse,
} from "../types/CheckJcUsertype";
import { ApiNames } from "../constant/ApiNames";
import { getRequest } from "./NetworkService";
import axios from "axios";
import { artworkBaseUrl } from "../constant/Config";

export const headerEnrichmentService = async () => {
  let endPoint = `${ApiNames.headerEnrichment}`;
  let { data }: { data: HeaderEnrichmentResponse } = await getRequest(endPoint);
  return data;
};

export const checkJCUserService = async (msisdn: string) => {
  let endPoint = `${ApiNames.checkjcUser}?msisdn=${msisdn}`;
  let { data }: { data: CheckJCUserResponse } = await getRequest(endPoint);
  return data;
};

export const getJcPlanService = async (planId: string) => {
  let endPoint = `${ApiNames.jcGetPlan}?plan_id=${planId}`;
  let { data }: { data: JcPlanResponse } = await getRequest(endPoint);
  return data;
};

export const getArtworkService = async (
  identifier: string,
  param_name: string,
) => {
  const { data }: { data: ArtworkResponse } = await axios.get(
    `${artworkBaseUrl}artwork`,
    { params: { identifier, param_name } },
  );
  return data;
};
